import type {Cindedi} from '@cindedi/spec/application';
import {createContext} from 'react';

export const ApplicationContext = createContext<Cindedi.Application | null>(null);
